import PropTypes from 'prop-types';

const LinkButton = {};

LinkButton.propTypes = {
    url: PropTypes.string,
    text: PropTypes.string,
    target: PropTypes.oneOf([
        "_blank"
    ]),
    isActive: PropTypes.bool
};

export default LinkButton;



// WEBPACK FOOTER //
// ./src/components/Models/LinkButton/LinkButton.jsx